<template>
  <div class="config-group small-12 medium-12 column d-flex flex-column align-items-center">
    <div class="config-item w-100 my-auto position-relative">
      <div class="config-item__info d-inline-flex">
        <label :for="option.id">{{option.name}}</label>
        <Tooltip v-if="tooltip" :infoText="tooltip"/>
      </div>

      <div class="d-flex gap-4 justify-space-between align-items-end">
        <InputStepper @change="changeSortenAmount" :min="option.customValues.minAnzahlSorten ?? 1" :max="option.customValues.maxAnzahlSorten" :value="option.dynamicValues.numSorten" />
        <button v-if="option.dynamicValues.numSorten > 1" class="btn btn--dark" @click="open">{{'textSortenverteilung'|translate}}</button>
      </div>
      <div v-if="message" class="text-small mt-prj text-error d-flex line-height-12 option-auflage-error">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
        {{ message }}
      </div>

      <SortenVerteilungModal ref="sortenVerteilungModalRef" :option="option" @saved="sortenInputModalSaved" />
    </div>
  </div>
</template>


<script>
import InputStepper from "./InputStepper.vue";
import FlyerlineModal from "../fragments/FlyerlineModal.vue";
import SelectricWrapper from "../fragments/SelectricWrapper.vue";
import SortenVerteilungModal from "./sortenverteilung/SortenVerteilungModal.vue";
import {SortenVerteilungService} from "../services/sorten-verteilung.service";
import Tooltip from "./Tooltip.vue";

export default {
  inject: ['configuratorService', 'configuratorService'],
  components: {Tooltip, SortenVerteilungModal, SelectricWrapper, FlyerlineModal, InputStepper},
  props: {
    option: {
      default: {}
    }
  },
  data() {
    return {
      numSorten: this.option.dynamicValues.numSorten,
      tooltip: this.option.tooltip
    }
  },
  created() {
    console.log("the options we got", this.option)
  },
  provide() {
    return {
      sortenVerteilungService: new SortenVerteilungService()
    }
  },
  methods: {
    open() {
      this.$refs.sortenVerteilungModalRef.open()
    },
    changeSortenAmount(value) {
      this.sortenAmount = value;
      this.option.dynamicValues.numSorten = value;
      this.configuratorService.validate()
    },
    sortenInputModalSaved() {
      this.configuratorService.validate();
    }
  },
  computed: {
    message() {
      if( this.option.currentInfo.msgType ) {
        return this.option.currentInfo.text
      } else {
        return "";
      }
    }
  }
}
</script>